import React from "react";
import { styled } from "@mui/system";

interface WrapperProps {
  width: string;
  height: string;
  color: string;
  hoverColor: string;
}

const Wrapper = styled("button")<WrapperProps>(({ width, height, color, hoverColor }) => ({
  display: "flex",
  width: width,
  height: height,
  color: color,
  padding: "4px 8px",
  justifyContent: "center",
  alignItems: "center",
  gap: "8px",
  background: "transparent",
  outline: "none",
  cursor: "pointer",
  borderRadius: "4px",
  border: "none",

  "&:hover > div:nth-of-type(2)": {
    color: hoverColor,
    textDecorationLine: "none",
  },
}));

interface IconWrapperProps {
  hide: boolean;
}
const IconWrapper = styled("div")<IconWrapperProps>(({ hide }) => ({
  width: "16px",
  height: "16px",
  paddingRight: "0.231px",
  justifyContent: "center",
  alignItems: "center",
  display: hide ? "none" : "flex",
}));

const Text = styled("div")(() => ({
  fontFamily: "Söhne",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "14px",
  textDecorationLine: "underline",
  textTransform: "capitalize",
}));

interface TextButtonProps {
  width?: string;
  height?: string;
  color?: "navy";
  icon?: JSX.Element;
  children: React.ReactNode;
  disabled?: boolean;
  onClick?: () => void;
}
const TextButton = (props: TextButtonProps) => {
  const { width = "fit-content", height = "100%", icon, color, children, onClick } = props;
  const iconNonExistent = !Boolean(icon);

  // text color
  let textColor = "";
  let textHoverColor = "";

  switch (color) {
    case "navy":
      textColor = "#002035";
      textHoverColor = "#4E7086";
      break;
    default:
      break;
  }

  return (
    <Wrapper
      width={width}
      height={height}
      color={textColor}
      hoverColor={textHoverColor}
      onClick={onClick}>
      <IconWrapper hide={iconNonExistent}>{icon}</IconWrapper>
      <Text>{children}</Text>
      <IconWrapper hide>{iconNonExistent}</IconWrapper>
    </Wrapper>
  );
};

export default TextButton;
